/**
 * Mirror of PortalB2B.Domain.Authorization.Permissions.All, consumed by the permission override
 * dialog. It is checked against the backend catalog by PermissionCatalogConformanceTests
 * (Spa_catalog_matches_the_domain_catalog) - adding a permission on one side and not the other
 * turns that test red, so this list cannot drift silently any more.
 *
 * Every code here also needs a `permission.<code>` label in all three i18n bundles; a second test
 * guards that. UI5 returns the key itself when a label is missing, so a missing label shows the
 * administrator a raw key rather than falling back to anything readable.
 */
export const PERMISSION_CATALOG: readonly string[] = [
	"orgs.read", "orgs.read-all", "orgs.create", "orgs.edit", "orgs.accept-registration", "orgs.suspend",
	"orgs.notes-read", "orgs.notes-write", "orgs.edit-integration", "orgs.edit_auto_extend_demo",
	"orgs.edit_payment_policy",
	"catalog.read", "catalog.manage",
	"contracts.read",
	"orders.read", "orders.create",
	"orders.pay", "orders.mark_overdue", "orders.downsell", "orders.create_demo",
	"entitlements.read", "entitlements.manage",
	"entitlements.register_payment", "entitlements.register_manual_entry",
	"entitlements.maintenance_manage", "entitlements.set_next_payment",
	"entitlements.activate", "entitlements.extend_grace",
	"deployments.read", "deployments.create", "deployments.enroll",
	"deployments.re_enroll", "deployments.decommission", "deployments.reset",
	"deployments.update_location",
	"deployments.set_owner",
	"locations.read", "locations.manage",
	"licenses.read", "licenses.create", "licenses.void", "licenses.assign", "licenses.revoke",
	"portal-users.read", "portal-users.invite", "portal-users.manage", "service-roles.manage",
	"delegation.set",
	"audit-log.read",
	"pricing.read", "pricing.write",
	"lr-outbox.read", "lr-outbox.retry",
	"promotions.read", "promotions.manage", "promotions.publish",
	"system-config.read", "system-config.write"
];
